const FRAME_SCHEDULED_FLAG = "__rosemountFrameScheduled";

export const installFrameResizeObserver = () => {
  if (typeof window === "undefined" || !window.ResizeObserver) return;
  if (window.ResizeObserver[FRAME_SCHEDULED_FLAG]) return;

  const NativeResizeObserver = window.ResizeObserver;

  class FrameResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frameId = null;
      let latestEntries = [];
      let latestObserver = null;

      super((entries, observer) => {
        latestEntries = entries;
        latestObserver = observer;

        if (frameId !== null) return;

        frameId = window.requestAnimationFrame(() => {
          frameId = null;
          callback(latestEntries, latestObserver);
        });
      });

      this.cancelScheduledCallback = () => {
        if (frameId === null) return;
        window.cancelAnimationFrame(frameId);
        frameId = null;
      };
    }

    disconnect() {
      this.cancelScheduledCallback();
      super.disconnect();
    }
  }

  FrameResizeObserver[FRAME_SCHEDULED_FLAG] = true;
  window.ResizeObserver = FrameResizeObserver;
};
